<template>
  <img v-show="store.state.isReady" class="Logo" src="@/assets/images/kenzo-homme-logo.svg" alt="">

  <Canvas />
  <Loader />
  <Welcome ref="start" v-on:startxp="onStartXp"/>
  <Intro ref="intro" />
  <End />
  <section class="Content">
    <Popin id="r11" video="https://player.vimeo.com/video/563344190/"/>
    <Popin id="r12" video="https://player.vimeo.com/video/563331880/"/>
    <Popin id="r13" video="https://player.vimeo.com/video/563342506/"/>
    <Popin id="r21" video="https://player.vimeo.com/video/563336351/"/>
    <Popin id="r22" video="https://player.vimeo.com/video/563340029/"/>
  </section>
  <UI />
</template>

<script>
import Canvas from '@/components/experience/Canvas.vue'
import Loader from '@/components/experience/Loader.vue'
import UI from '@/components/experience/UI.vue'
import Welcome from '@/components/experience/Welcome.vue'
import Popin from '@/components/experience/Popin.vue'
import End from '@/components/experience/End.vue'
import Intro from '@/components/experience/Intro.vue'

export default {
  name: 'App',
  components: {
    Canvas,
    Loader,
    UI,
    Welcome,
    Popin,
    End,
    Intro,
  },
  inject: ['store'],
  mounted() {
  },
  methods: {
    onStartXp() {
      this.$refs.intro.open()
      // this.store.start()
      // emitter.emit('SOUND', true)
    }
  }
}
</script>

<style lang="stylus">
.Logo
  position absolute
  z-index 10
  left 50%
  transform translateX(-50%)
  width 210px
  top 6vh

@media screen and (max-height: 800px)
  .Logo
    width 100px
</style>
